import GoalAndOperationalPlans from './GoalAndOperationalPlans';

export default GoalAndOperationalPlans;
